// frontend/src/components/LanguageSwitcher.jsx - FIXED VERSION
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ className = '', variant = 'default' }) => {
  const { language, toggleLanguage, isEnglish } = useLanguage();

  // Different variants for different contexts
  const variants = {
    default: {
      container: `flex items-center justify-between w-full px-3 py-2 rounded-lg bg-gray-700 hover:bg-gray-600 transition-colors cursor-pointer ${className}`,
      icon: 'text-gray-300',
      text: 'text-gray-300 text-sm font-medium',
      showBoth: true
    },
    minimal: {
      container: `flex items-center space-x-1 px-2 py-1 rounded hover:bg-gray-800 transition-colors cursor-pointer ${className}`,
      icon: 'text-gray-400',
      text: 'text-gray-400 text-xs',
      showBoth: false
    },
    header: {
      container: `flex items-center space-x-2 px-3 py-2 rounded-lg border border-gray-600 hover:border-gray-500 bg-gray-800 hover:bg-gray-700 transition-all cursor-pointer ${className}`,
      icon: 'text-white',
      text: 'text-white text-sm font-medium',
      showBoth: true
    },
    button: {
      container: `inline-flex items-center space-x-2 px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 text-white transition-colors cursor-pointer ${className}`,
      icon: 'text-white',
      text: 'text-white text-sm font-medium',
      showBoth: false
    },
    sidebar: {
      container: `flex items-center justify-between w-full px-3 py-2 rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors cursor-pointer ${className}`,
      icon: 'text-gray-300',
      text: 'text-gray-300 text-sm',
      showBoth: true
    }
  };

  const currentVariant = variants[variant] || variants.default;

  return (
    <button
      onClick={toggleLanguage}
      className={currentVariant.container}
      title={isEnglish ? 'Switch to Chinese (切换到中文)' : 'Switch to English (切换到英文)'}
      aria-label={isEnglish ? 'Switch to Chinese' : 'Switch to English'}
    >
      <div className="flex items-center space-x-2">
        <Globe size={16} className={currentVariant.icon} />
        <span className={currentVariant.text}>
          {isEnglish ? 'English' : '中文'}
        </span>
      </div>
      
      {currentVariant.showBoth && (
        <span className={`${currentVariant.text} opacity-60`}>
          {isEnglish ? '中文' : 'EN'}
        </span>
      )}
    </button>
  );
};

// FIXED Flag Language Switcher - now properly working
export const FlagLanguageSwitcher = ({ className = '' }) => {
  const { toggleLanguage, isEnglish } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className={`inline-flex items-center justify-center px-3 py-2 rounded-lg bg-gray-700 hover:bg-gray-600 transition-colors text-white text-sm font-medium border border-gray-600 hover:border-gray-500 ${className}`}
      title={isEnglish ? 'Switch to Chinese (切换到中文)' : 'Switch to English (切换到英文)'}
    >
      <span className="text-lg mr-2" role="img" aria-label={isEnglish ? 'US flag' : 'Chinese flag'}>
        {isEnglish ? '🇺🇸' : '🇨🇳'}
      </span>
      <span className="mr-1">
        {isEnglish ? 'EN' : '中文'}
      </span>
      <span className="text-gray-400 text-xs">
        / {isEnglish ? '中文' : 'EN'}
      </span>
    </button>
  );
};

// Simple toggle version with flags
export const SimpleLanguageToggle = ({ className = '' }) => {
  const { toggleLanguage, isEnglish } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className={`inline-flex items-center justify-center px-3 py-2 rounded-lg bg-gray-700 hover:bg-gray-600 transition-colors text-white text-sm font-medium border border-gray-600 hover:border-gray-500 ${className}`}
      title={isEnglish ? 'Switch to Chinese' : 'Switch to English'}
    >
      <span className="mr-1">{isEnglish ? '🇺🇸' : '🇨🇳'}</span>
      {isEnglish ? 'EN' : '中文'}
      <span className="mx-1 text-gray-400">|</span>
      <span className="text-gray-400 text-xs">
        {isEnglish ? '中文' : 'EN'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;